import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Conferenceanddelegationcarrental() {



  const cardData =
  {
    keyword: ' Conference & Delegation Car Rental Services in Pune ',
    heading: 'Pune Corporate Cars India Private Limited: Conference & Delegation Car Rental Services in Pune ',
    headingDescription: 'Pune Corporate Cars India Private Limited provides premium Conference & Delegation Car Rental Services in Pune, ensuring seamless and professional transportation for corporate events, business conferences, exhibitions, trade fairs, and high-level delegations across the city. Our fleet of executive sedans, SUVs, MUVs, and luxury vehicles offers safe, comfortable, and on-time travel for delegates, speakers, VIPs, and corporate guests. Whether it is airport pick-ups, hotel transfers, event commute, inter-city travel, or full-day car rentals, we deliver organized and hassle-free mobility solutions. With well-trained chauffeurs, GPS-enabled vehicles, 24×7 support, flexible billing, and dedicated coordination teams, Pune Corporate Cars India Private Limited provides a reliable, smooth, and high-standard travel experience for all corporate conferences and delegations in Pune.',

    top: 'Top Places to Visit in Pune with Pune Corporate Car',

"topPlaces": [
    {
      "title": "Hinjewadi Rajiv Gandhi Infotech Park",
      "description": "Hinjewadi Phase 1, 2 and 3 together form Pune’s largest corporate ecosystem, home to global IT companies, MNCs, tech parks, and business hubs. With campuses of Infosys, Wipro, Cognizant, TCS and more, it is Pune’s primary employment corridor. The area has wide roads, 24×7 transport demand, cafes, business hotels, and constant corporate mobility needs — making it one of the busiest routes served by Pune Corporate Cars."
    },
    {
      "title": "Magarpatta Cybercity",
      "description": "Magarpatta Cybercity is a self-sustained corporate township combining IT parks, residential spaces, restaurants, and premium office buildings. Known for its clean, green, and secure environment, it hosts major IT giants like Accenture, Infosys, Capgemini and Barclays. Corporate travel requirements, employee drop services, and daily office commutes make it a major business hub in Pune."
    },
    {
      "title": "Kharadi EON IT Park",
      "description": "EON IT Park is Pune’s fastest-growing commercial destination, filled with high-rise IT towers, premium offices, and multinational companies. Its four major clusters (A, B, C, D) attract thousands of daily employees. With tech companies, co-working spaces, and international business centers, Kharadi is a top route for corporate pick-drop and airport transfers."
    },
    {
      "title": "Viman Nagar Business District",
      "description": "Viman Nagar is a premium corporate and lifestyle hub near Pune Airport, known for its modern business centers, coworking spaces, hotels, and commercial complexes. Major malls, restaurants, and connectivity to Kharadi, Koregaon Park, and Yerwada make it a preferred zone for corporate travel, meetings, and executive cab services."
    },
    {
      "title": "Baner–Balewadi Corporate Hub",
      "description": "Baner and Balewadi have transformed into Pune’s new-age commercial cluster with IT companies, startups, co-working hubs, and premium business towers. It offers a cosmopolitan corporate environment with cafés, boardrooms, and business hotels. The area’s proximity to Hinjewadi makes corporate cab requirements extremely high for daily office mobility."
    },
    {
      "title": "Chakan MIDC Industrial Area",
      "description": "Chakan MIDC is one of India’s biggest industrial and automobile manufacturing clusters, housing companies like Volkswagen, Mercedes-Benz, Bajaj, LG, and Mahindra. With 24×7 transport operations, staff shifts, and inter-plant travel, it is a prime location served by corporate cab services, staff shuttle operations, and industrial commute solutions."
    },
    {
      "title": "Talegaon MIDC",
      "description": "Talegaon MIDC is known for its global manufacturing units, auto plants, and logistics hubs. It hosts companies such as General Motors, L&T, JCB, and POSCO. The area witnesses heavy employee movement and frequent business visits from executives — making structured corporate mobility critical for smooth travel between Pune city and the MIDC."
    },
    {
      "title": "Yerwada Business Corridor",
      "description": "Yerwada is a major commercial zone with corporate towers, business parks, and high-end office spaces like ICC Tech Park and Commerzone. It is a preferred location for corporate meetings, finance companies, and consulting firms. Its close connectivity to the airport and EON makes it a frequent route for corporate cabs and executive travel."
    },
    {
      "title": "Koregaon Park Business & Lifestyle District",
      "description": "Koregaon Park blends premium business centers with high-end lifestyle spaces, cafés, and boutique offices. It attracts startups, creative agencies, international firms, and co-working workspaces. The area is ideal for board meetings, client visits, and VIP travel — heavily relying on professional chauffeur-driven cabs."
    },
    {
      "title": "Pimpri-Chinchwad Industrial Belt",
      "description": "PCMC is one of Pune’s strongest industrial belts, filled with auto, engineering, and manufacturing companies. Areas like Pimpri, Chinchwad, Bhosari, and Nigdi host major factories and R&D centers. With shift-based employee travel and factory visits, corporate cab services remain essential for day-to-day operations."
    }
  ],


"services": [
  {
    "name": "Corporate Conference Transport Pune",
    "description": "Corporate Conference Transport Pune provides end-to-end transport solutions for conferences, seminars, and corporate events. Services include scheduled pickups, dedicated shuttles, and GPS-monitored travel to ensure delegates arrive on time and comfortably."
  },
  {
    "name": "Delegates Car Rental Pune",
    "description": "Delegates Car Rental Pune offers premium and standard cars for corporate delegates, ensuring reliable, comfortable, and punctual travel between hotels, venues, and business meetings with professional chauffeurs."
  },
  {
    "name": "VIP Chauffeur Service Pune",
    "description": "VIP Chauffeur Service Pune provides dedicated chauffeur-driven luxury vehicles for executives and VIP delegates attending corporate events, conferences, and high-profile meetings, delivering a premium and seamless travel experience."
  },
  {
    "name": "Business Meeting Cab Pune",
    "description": "Business Meeting Cab Pune offers flexible, timely, and comfortable transportation for executives and employees attending business meetings, with sedans, SUVs, and luxury cars available on-demand."
  },
  {
    "name": "Event Transportation Pune",
    "description": "Event Transportation Pune specializes in coordinated transport services for corporate events, trade shows, and seminars, including group shuttle services, multi-vehicle fleets, and real-time ride monitoring."
  },
  {
    "name": "Luxury Cars for Delegates Pune",
    "description": "Luxury Cars for Delegates Pune provides high-end sedans, SUVs, and executive vehicles for VIP delegates attending corporate events, ensuring comfort, elegance, and a professional impression."
  },
  {
    "name": "Conference Shuttle Pune",
    "description": "Conference Shuttle Pune delivers high-capacity shuttle services for delegates and staff, optimized for multiple routes, group pickups, and drop-offs, ensuring punctual and organized travel across event venues."
  },
  {
    "name": "Executive Fleet Pune",
    "description": "Executive Fleet Pune offers a managed fleet of premium vehicles for corporate delegates, executives, and event attendees. Services include GPS tracking, professional chauffeurs, and end-to-end fleet management for seamless mobility."
  },
  {
    "name": "Outstation Delegate Transport Pune",
    "description": "Outstation Delegate Transport Pune provides long-distance corporate travel solutions for delegates attending conferences and meetings outside the city, with comfortable sedans and SUVs, trained drivers, and real-time monitoring."
  },
  {
    "name": "Airport Delegate Transfer Pune",
    "description": "Airport Delegate Transfer Pune ensures timely and secure pickups and drop-offs for delegates arriving at or departing from Pune airport, with a range of vehicle options including sedans, SUVs, and luxury cars."
  },
  {
    "name": "Corporate Event Cab Pune",
    "description": "Corporate Event Cab Pune delivers dedicated transportation services for corporate events, including VIP travel, guest transfers, and multi-vehicle coordination, ensuring smooth and professional commuting for all attendees."
  },
  {
    "name": "Premium Car Rental Pune",
    "description": "Premium Car Rental Pune offers high-end, well-maintained vehicles for corporate use, executive travel, and delegate transport during events, featuring luxury sedans, SUVs, and chauffeur services."
  },
  {
    "name": "Sedan Rental Pune",
    "description": "Sedan Rental Pune provides comfortable and reliable sedans for corporate delegates, event attendees, and staff, ensuring punctuality, safety, and professional chauffeur services for daily or event-based travel."
  },
  {
    "name": "SUV Rental Pune",
    "description": "SUV Rental Pune offers spacious and high-comfort SUVs for group or executive travel during corporate events, conferences, and business meetings, with professional drivers and GPS tracking."
  },
  {
    "name": "Delegate Mobility Pune",
    "description": "Delegate Mobility Pune ensures seamless mobility for conference and event delegates, providing customized transportation solutions, multi-vehicle coordination, and professional service to enhance event logistics."
  }
],

"tableData": [
  ["Corporate Conference Transport Pune", "Delegates Car Rental Pune"],
  ["VIP Chauffeur Service Pune", "Business Meeting Cab Pune"],
  ["Event Transportation Pune", "Luxury Cars for Delegates Pune"],
  ["Conference Shuttle Pune", "Executive Fleet Pune"],
  ["Outstation Delegate Transport Pune", "Airport Delegate Transfer Pune"],
  ["Corporate Event Cab Pune", "Premium Car Rental Pune"],
  ["Sedan Rental Pune", "SUV Rental Pune"],
  ["Delegate Mobility Pune", ""]
],


  





"whychoose": [
  {
    "WhyChooseheading": "Conference & Delegation Car Rental Services in Pune",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited offers professional car rental services in Pune for conferences, corporate delegations, and business events, ensuring smooth and reliable transportation for VIPs and executives."
  },
  {
    "WhyChooseheading": "Timely Pickups & Drop-offs",
    "WhyChoosedescription": "We ensure punctual pickups and drop-offs for delegates and conference attendees, helping them reach venues, hotels, and airports on schedule."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our trained chauffeurs provide safe, courteous, and disciplined travel, ensuring a secure and comfortable experience for conference delegates and VIP guests."
  },
  {
    "WhyChooseheading": "Well-Maintained Vehicle Fleet",
    "WhyChoosedescription": "Choose from sedans, SUVs, tempo travellers, and buses—all sanitized, serviced, and maintained for reliable and comfortable travel for corporate events and delegations in Pune."
  },
  {
    "WhyChooseheading": "Customized Corporate Travel Packages",
    "WhyChoosedescription": "We provide flexible and tailored car rental solutions to meet the specific transportation needs of conferences, delegations, and corporate events."
  },
  {
    "WhyChooseheading": "24/7 Corporate Travel Support",
    "WhyChoosedescription": "Our team provides round-the-clock assistance for bookings, route adjustments, and emergencies, ensuring uninterrupted travel during conferences and events."
  },
  {
    "WhyChooseheading": "Safe & Hygienic Rides",
    "WhyChoosedescription": "All vehicles are sanitized regularly and equipped with modern safety features, offering secure and comfortable rides for delegates and executives."
  },
  {
    "WhyChooseheading": "Efficient Booking & Coordination",
    "WhyChoosedescription": "Corporate travel is streamlined through our easy booking system and reliable coordination, making transport for conferences and delegations hassle-free."
  }
]





















  }

  
const faqData = [
  {
    question: 'Do you provide conference and delegation car rental services in Pune?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers professional and reliable car rental services for conferences, corporate delegations, and business events in Pune.',
  },
  {
    question: 'What types of services are available for conferences and delegations?',
    answer: 'We provide airport transfers, city transfers, shuttle services, multi-vehicle coordination, and VIP transportation for delegates and corporate guests.',
  },
  {
    question: 'Can multiple cars be booked for large delegations in Pune?',
    answer: 'Absolutely. We provide multiple vehicles simultaneously for large groups, ensuring timely and coordinated transport for all delegates.',
  },
  {
    question: 'How can companies book conference and delegation car rental services?',
    answer: 'Bookings can be made via our website, mobile app, or by contacting our dedicated 24×7 corporate support team.',
  },
  {
    question: 'Which vehicles are available for conference and delegation transport?',
    answer: 'We offer sedans, SUVs, luxury cars, Innova Crysta, tempo travellers, and electric vehicles to suit the scale and requirements of any event.',
  },
  {
    question: 'Do you offer long-term or event-specific contracts for corporate events?',
    answer: 'Yes, we provide flexible contracts, whether for a single event, multiple-day conferences, or recurring corporate gatherings.',
  },
  {
    question: 'Are vehicles GPS-enabled and safe for delegates?',
    answer: 'All vehicles are GPS-enabled, sanitized regularly, and driven by trained, professional chauffeurs to ensure safety and comfort.',
  },
  {
    question: 'Do you handle last-minute changes for conference transport schedules?',
    answer: 'Absolutely. We provide flexible and reliable solutions to accommodate schedule changes, delays, or additional transport requirements.',
  },
  {
    question: 'What payment options are available for corporate conference car rentals?',
    answer: 'We accept UPI, bank transfers, credit/debit cards, digital wallets, and provide consolidated corporate invoicing.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Raghav Joshi',
    feedback: 'Excellent conference and delegation car rental service in Pune. Vehicles were punctual, clean, and well-coordinated for our event.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Shruti Kapoor',
    feedback: 'Reliable and professional service for our corporate delegation. Smooth coordination and comfortable rides made our event hassle-free.',
    rating: 5,
  },
];



















































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Conference & Delegation Car Rental Services in Pune",
  "image": "https://www.punecorporatecars.com/assets/images/conference-delegation-cab-service-pune.jpg", // replace with actual image URL
  "description":
    "Pune Corporate Cars India Private Limited offers specialized Conference & Delegation Car Rental Services in Pune, providing luxury cars for delegates, business meeting transport, executive fleet for conferences, VIP chauffeur services, airport transfers for delegates, outstation transport for conferences, and premium event transportation solutions for corporate events and meetings.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5800",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3000",
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/conference-delegation-car-rental-pune"
  }
};




  return (
    <div>
<Helmet>
  <title>Conference & Delegation Car Rental Services in Pune | Luxury & VIP Transport</title>

  <meta
    name="description"
    content="Conference & Delegation Car Rental Services in Pune offering luxury cars for delegates, VIP chauffeur services, event transport, business meeting cabs, executive fleets, outstation delegate transport, and premium car rentals for corporate events."
  />

  <meta
    name="keywords"
    content="Corporate Conference Transport Pune, Delegates Car Rental Pune, VIP Chauffeur Service Pune, Business Meeting Cab Pune, Event Transportation Pune, Luxury Cars for Delegates Pune, Conference Shuttle Pune, Executive Fleet Pune, Outstation Delegate Transport Pune, Airport Delegate Transfer Pune, Corporate Event Cab Pune, Premium Car Rental Pune, Sedan Rental Pune, SUV Rental Pune, Delegate Mobility Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/106.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Conferenceanddelegationcarrental;